import _ from 'lodash'
import {
  ChartToolTip,
  Title,
  Item,
  ItemIcon
} from '../../../../Common/NewDashboard/Chart/ToolTip'
import { getDashboardDateTime } from '../../../../../lib/MomentHelper'
import { dollarFormat, numeralFormat } from '../../../../../../lib/renderUtil'

const SalesPerformanceTooltip = props => {
  const { active, payload } = props
  if (!active) {
    return null
  }

  const data = _.get(payload, '[0].payload', {})
  const reportDate = _.get(data, 'reportDate', '')
  const amount = _.toNumber(_.get(data, 'amount', 0))
  const soldQuantity = _.toNumber(_.get(data, 'soldQuantity', 0))
  const pageView = _.toNumber(_.get(data, 'pageView', 0))
  const totalViewerQuantity = _.toNumber(_.get(data, 'totalViewerQuantity', 0))
  const conversionRate = pageView > 0 ? (soldQuantity / pageView) * 100 : 0
  return (
    <ChartToolTip>
      <Title>
        {getDashboardDateTime(reportDate)}
      </Title>
      <Item>
        <ItemIcon color='#6a96f3' />
        {`訂購金額：${dollarFormat(amount)}`}
      </Item>
      <Item>
        <ItemIcon color='#7dd5a9' />
        {`訂購量：${numeralFormat(soldQuantity, { allowZero: true })}`}
      </Item>
      <Item>
        {`瀏覽量：${numeralFormat(pageView, { allowZero: true })}`}
      </Item>
      <Item>
        {`轉換率：${numeralFormat(conversionRate, { allowZero: true })}%`}
      </Item>
      <Item>
        {`不重複訪客數：${numeralFormat(totalViewerQuantity, { allowZero: true })}`}
      </Item>
    </ChartToolTip>
  )
}

export default SalesPerformanceTooltip
